import { createApi } from "@reduxjs/toolkit/query/react";
import { listAlertsRequest, listAlertsResponse } from "../../types";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";

export const alertApi = createApi({
  reducerPath: "alertApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Alert"],
  endpoints: (builder) => ({
    listAlerts: builder.query<listAlertsResponse, listAlertsRequest>({
      query: (params) => ({
        url: "/alerts",
        method: "GET",
        params,
      }),
      providesTags: ["Alert"],
      onQueryStarted: withErrorNotification("Failed to fetch alerts"),
    }),
  }),
});

export const { useListAlertsQuery } = alertApi;
